export const clickElementByID = (id) => {
	const element = document.getElementById(id);
	if (element) {
		element.click();
	}
};